import { Link } from "react-router-dom";
import dateUtil from "../utils/dateUtil";
import moment from "moment";
import { useMemo } from "react";
import UpdateNotice from "../components/updateNotice";

const LOCALES = {
  title: {
    label: {
      fr: "Commerce international en ligne",
      en: "International Trade Data Online",
    },
  },
  "latest-date": {
    label: {
      fr: "Mise à jour des données",
      en: "Updated",
    },
  },
  "btn-sh": {
    link: "/sh-hs",
    label: {
      fr: "Commerce international par produit (SH)",
      en: "International trade data by product (HS)",
    },
  },
  "btn-scian": {
    link: "/scian-naics",
    label: {
      fr: "Commerce international par industrie (SCIAN)",
      en: "International trade data by industry (NAICS)",
    },
  },
};

//TODO Refactorer pour prendre en considération une liste de date-heure et composant <UpdateNotice />
const Index = ({
  lang,
  curDate = moment(),
  latestUpdateISQ,
  latestUpdateStatCan,
}) => {
  return (
    <>
      <div className="page page-index">
        <section className="row">
          {lang === "en" && (
            <div className="cadre-vert" style={{ margin: "0 0 15px 0" }}>
              <div>
                The <em>Charter of the French language</em> and its regulations
                govern the{" "}
                <a
                  target="_blank"
                  className=" lien-externe"
                  href="https://www.quebec.ca/en/gouvernement/politiques-orientations/langue-francaise/modernization-charter-french-language#c214034"
                  rel="noopener noreferrer"
                >
                  consultation of English-language content
                </a>
                .
              </div>
            </div>
          )}
          <header className="col-xs-12">
            <h1>{LOCALES.title.label[lang]}</h1>
          </header>
          <article className="small col-xs-12">
            {lang === "en" ? (
              <p>
                The International Trade Data Online (ITDO) tool provides the
                ability to generate customized reports on Québec’s and Canada’s
                international trade in goods with over 200 countries.
              </p>
            ) : (
              <p>
                L'outil Commerce international en ligne (CIEL) vous permet
                d'exécuter à volonté des rapports sur mesure sur le commerce
                international de marchandises du Québec et du Canada avec plus
                de 200 pays.
              </p>
            )}
            <UpdateNotice
              lang={lang}
              currentDate={curDate}
              latestUpdateISQ={latestUpdateISQ}
              latestUpdateStatCan={latestUpdateStatCan}
            />
            <ul className="list-unstyled">
              <li>
                <Link
                  to={LOCALES["btn-sh"].link}
                  className="btn btn-primary marg-b-15 max-w-345-responsive text-wrap align_left"
                >
                  {LOCALES["btn-sh"].label[lang]}
                </Link>
              </li>
              <li>
                <Link
                  to={LOCALES["btn-scian"].link}
                  className="btn btn-primary marg-b-15 max-w-345-responsive text-wrap align_left"
                >
                  {LOCALES["btn-scian"].label[lang]}
                </Link>
              </li>
            </ul>
            {lang === "en" ? (
              <p>
                Based on the Institut de la statistique du Québec’s{" "}
                <Link to={"renseignements-information"}>most recent data</Link>.
              </p>
            ) : (
              <p>
                Avec les plus{" "}
                <Link to={"renseignements-information"}>récentes données</Link>{" "}
                de l’Institut de la statistique du Québec.
              </p>
            )}
            <p>
              {LOCALES["latest-date"].label[lang]}:&nbsp;
              <span>{dateUtil.dateToString(latestUpdateISQ, lang, "LL")}</span>
            </p>
          </article>
        </section>
      </div>
    </>
  );
};
export default Index;
